<h1 class="save-line-head" i18n='@@title-PaymentMethods'>Metodi di pagamento</h1>

<h4 i18n='@@textint-IntroPaymentMethods'>
  Worldline dispone di diversi metodi di pagamento che possono essere accettati con una sola integrazione, tra cui carte di credito come VISA, VISA Electron, Vpay, Mastercard, Maestro, American Express e Diners e metodi di pagamento aggiuntivi non basati su carta
</h4>

<div class="menu-row-container">
<div class="menu-row">
  @for (pdf of listPdf; track pdf) {
    @if (showPdf(pdf)) {
      <a class="menu-link">
        <mat-card class="menu-card" (click)="openPdf(pdf.file)">
          <div class="menu-content">
            <mat-icon svgIcon="credit-card" class="start-icon" style="margin-right: 15px;"></mat-icon>

            <span class="label">
              @if (currentLanguage === 'it') {
                {{ pdf.title_version_IT }}
              }
              @if (currentLanguage === 'en') {
                {{ pdf.title_version_EN }}
              }
              @if (!currentLanguage) {
                {{ pdf.title_version_EN }}
              }
            </span>

            <mat-icon class="end-icon" style="flex: 1 1 auto; text-align: end;">keyboard_arrow_right</mat-icon>
          </div>
        </mat-card>
      </a>
    }
  }
</div>
</div>
